import classnames from "classnames";
import React, { type PropsWithChildren } from "react";

interface DetailsItemProps {
  className?: string;
  title?: string;
}

const DetailsItem = ({
  className,
  title,
  children,
}: PropsWithChildren<DetailsItemProps>) => {
  return (
    <section className={classnames(className)}>
      {title && <h2 className="mb-4 text-lg font-bold">{title}</h2>}
      <div className="whitespace-pre-line">{children}</div>
    </section>
  );
};

export default DetailsItem;
